module.exports = "/images/vendor/photoswipe/dist/default-skin/default-skin.png?0ff4d62150facee6b7dec616100ad3da";